import React, { useState } from 'react';
import { Flex } from 'components/base/layout-components';
import { ResponsiveContainer, AreaChart, Area, Tooltip } from 'recharts';
import TrendLineToolTip from './TrendLineToolTip';
import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';
import { getClickableMetrics, onDotClick } from '../GroupMetricsWidget.service';
import useSettingsService from 'components/hooks/useSettingsService';

const StyledFlex = styled(Flex)`
  .recharts-tooltip-cursor {
    stroke: transparent;
  }
  .recharts-tooltip-wrapper {
    z-index: 100;
  }
  .recharts-surface {
    ${({ cursor }) => (cursor ? 'cursor: pointer;' : '')}
  }
`;

const TrendLine = ({
  trendLineData,
  displayLabel,
  widgetMetricName,
  selectedGroupId
}) => {
  const { getSettingOrDefinitionValue } = useSettingsService();

  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  const onMouseEnter = e => {
    const tooltipHeight = 90;
    setTooltipPosition({ x: e.x, y: tooltipHeight });
  };
  const metricsNotclickableIncludesMTTRCFR = getClickableMetrics();

  const activeDotConfig = {
    onClick: (event, payload) =>
      onDotClick(
        payload,
        widgetMetricName,
        selectedGroupId,
        getSettingOrDefinitionValue
      )
  };

  const isDotClickable =
    !metricsNotclickableIncludesMTTRCFR.includes(widgetMetricName);

  return (
    <StyledFlex height='7rem' pl='1.5rem' pr='1.5rem' cursor={isDotClickable}>
      <ResponsiveContainer width='100%' height='100%'>
        <AreaChart data={trendLineData}>
          <defs>
            <linearGradient id='linearGr' x1='0' y1='0' x2='0' y2='1'>
              <stop
                offset='30%'
                stopColor={getColor('dodgerBlue')}
                stopOpacity={0.4}
              />
              <stop
                offset='50%'
                stopColor={getColor('dodgerBlue')}
                stopOpacity={0.25}
              />
              <stop
                offset='80%'
                stopColor={getColor('dodgerBlue')}
                stopOpacity={0.05}
              />
              <stop
                offset='100%'
                stopColor={getColor('dodgerBlue')}
                stopOpacity={0.01}
              />
            </linearGradient>
          </defs>
          <Tooltip
            position={tooltipPosition}
            allowEscapeViewBox={{ y: true }}
            content={
              <TrendLineToolTip
                displayLabel={displayLabel}
                widgetMetricName={widgetMetricName}
              />
            }
          />
          <Area
            dot={{
              fill: 'white',
              r: 2.5
            }}
            type='monotone'
            dataKey='data'
            stroke={getColor('dodgerBlue')}
            strokeWidth={1.5}
            fillOpacity={1}
            fill='url(#linearGr)'
            onMouseEnter={onMouseEnter}
            isAnimationActive={false}
            {...(isDotClickable && {
              activeDot: activeDotConfig
            })}
          />
        </AreaChart>
      </ResponsiveContainer>
    </StyledFlex>
  );
};

export default TrendLine;
